export const addDateDays = (date: string, days: number) => {
  const newDate = new Date(date);
  return newDate.setDate(newDate.getDate() + days);
};
